const API_KEY_NAME = 'api_token';
export default API_KEY_NAME;
